var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.72,7.57l-5.3-5.29A1,1,0,0,0,15.74,2H8.25a1,1,0,0,0-.68.28L2.28,7.57A1,1,0,0,0,2,8.25v7.5a1,1,0,0,0,.28.68l5.29,5.29a1,1,0,0,0,.68.28h7.49a1,1,0,0,0,.68-.28l5.3-5.29a1,1,0,0,0,.28-.68V8.25A1,1,0,0,0,21.72,7.57Zm-1.94,7.65h0L15.5,19.5a1,1,0,0,1-.68.28H9.17a1,1,0,0,1-.68-.28l-4-4a1,1,0,0,1-.28-.68V9.18A1,1,0,0,1,4.5,8.5l4-4a1,1,0,0,1,.68-.28h5.65a1,1,0,0,1,.68.28l4,4a1,1,0,0,1,.29.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14.53a.84.84,0,1,0,.84.84A.84.84,0,0,0,12,14.53Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.15,
    y: 7.79,
    width: 1.69,
    height: 5.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e01182b9a7ea6ebefa0e406e896122e6.svg";
export { ForwardRef as ReactComponent };